import { render, staticRenderFns } from "./ServidorCorreo.vue?vue&type=template&id=45be8647&scoped=true&lang=pug&"
import script from "./ServidorCorreo.vue?vue&type=script&lang=js&"
export * from "./ServidorCorreo.vue?vue&type=script&lang=js&"
import style0 from "./ServidorCorreo.vue?vue&type=style&index=0&id=45be8647&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be8647",
  null
  
)

export default component.exports